var exports = {
  "G": "x127c5a35--e4829c--pagination-error",
  "L": "x127c5a35--e4829c--pagination-error-button",
};

module.exports = exports;
